// ------------------------------ IMPORTS
// *    Style imports
import './styles.css'

// *    Library imports
import React,{Component} from "react";
import PropTypes from 'prop-types';
// import PubSub from "pubsub-js";


// *    Component imports
import {xhrGetDbCompanyInfoList, xhrGetProfileViewNumber, xhrSaveUpgradeInfo, xhrGetCoinsInfo} from "./Services/Services";
import Constants from "../../../../constants/Constants";
import LoadingViewSmall from "../LoadingView/LoadingViewSmall";
// import DataBaseViewRight from "./Component/dataBaseViewRight/DataBaseViewRight";
// import ServerErrorHandlerView from "../../../ErrorView/ServerError";
import DataBaseViewLeft from "./Component/DataBaseViewLeft/DataBaseViewLeft";
import Gutter from "../../../Gutter/Gutter";
import Content from "../../../../content/Content";



// ----------------------------- END IMPORTS

class DataBaseView extends Component {
    constructor(props){
        super(props);
        this.state = {
            jobId: null,
            serverCallStatus : Constants.REQUEST_STATS.PENDING,
            companyLogoUrl: null,
            jobDesignation: null,
            companyName: null,
            locationList: null,
            profileCount: null,
            coinsCount: null,
            rate: null,
            pricing: null,
            maxProfileCount: null
        };
        this.receivedData = null;
        this.hasError = false;
        // this.receivedDataProfile = null;
    }

    componentWillMount(){
        
    }

    componentDidMount() {
        
    }

    componentWillUnmount () {
        
    }

    // --------------------------------------------------------- helper function



    setServerCallStatus = (status) => {
        this.setState({
            serverCallStatus : status
        })
    };


    // --------------------------------------------------------- Server calls




    // --------------------------------------------------------- listeners


    // --------------------------------------------------------- views

    getViewToBeRendered = (serverCallStatus) => {
        let renderView = null ;
        switch (serverCallStatus) {
            case 1:
                renderView = this.getLoadingPage();
                break;
            case 2:
                renderView = this.getDataView();
                break;
            case 3:
                renderView = this.getErrorView();
                break;
            default :
                break;
        }
        return renderView;
    };

    getLoadingPage = () => {
        return <LoadingViewSmall/>
    };


    getErrorView = () => {
        // return <ServerErrorHandlerView />
        return null;
    };

    // --------------------------------profileCountOnChange------------------------- render
    render(){
        return (
            <div className="data-base-view">
                <div className="content-view">
                    <DataBaseViewLeft
                        rate={this.state.rate}
                        maxProfileCount={this.state.maxProfileCount}
                        rate = {this.props.rate}
                    />
                    <Gutter width={17}/>
                </div>
            </div>
        ) ;
    }

}

/**
 * all prop types which can be passed to this component
 */
DataBaseView.propTypes ={
    jobId : PropTypes.number.isRequired,
    onSuccess : PropTypes.func.isRequired,

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
DataBaseView.defaultProps ={

};

export default DataBaseView;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetDataBaseView/GetDataBaseView.js